import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {BonusBunniesParsedGameData} from "../../server/data/BonusBunniesParsedGameData";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {BonusBunniesGameModuleConfig} from "../../BonusBunniesGameModuleConfig";
import {BonusBunniesB5NearWinView} from "./BonusBunniesB5NearWinView";
import {BonusBunniesGameMode} from "../../gamemode/BonusBunniesGameMode";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {BonusBunniesParsedInitData} from "../../server/data/BonusBunniesParsedInitData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BonusBunniesSoundConfig} from "../../BonusBunniesSoundConfig";

/**
 * Created by Jerker Nord on 2020-02-13.
 */

export class BonusBunniesB5NearWinController extends ReelStopPresentationController {

    private _nearWinReel:number;
    private _b5NearWinView:BonusBunniesB5NearWinView;
    private _b5NearWinPosition:number[];
    private _currentMode:string;
    private _nextMode:string;
    private _endBonusMultiplier:number;
    private _bonusPositionsBeforeSpin:boolean[][];
    private _bottomRowActivated:boolean;
    private _lastReelActivated:boolean;

    constructor(index:number) {
        super(index, "BonusBunniesB5NearWinController");
        this._b5NearWinView = BonusBunniesGameModuleConfig.bonusBunniesB5NearWinView = new BonusBunniesB5NearWinView();
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    private onInitDataParsed(data:BonusBunniesParsedInitData):void {
        this._currentMode = data.mode;
        this._nextMode = data.nextMode;
    }

    protected parseFeatureGameData(data:BonusBunniesParsedGameData):void {
        this._endBonusMultiplier = data.endBonusMultiplier;
        this._b5NearWinPosition = data.lastBonusSymbolPositionExcitement;
        this._currentMode = data.mode;
        this._nextMode = data.nextMode;
        this._bonusPositionsBeforeSpin = data.bonusPositionsBeforeSpin;
        this._bottomRowActivated = data.bottomRowActivated;
        this._lastReelActivated = data.lastReelActivated;
        if(data.lastBonusSymbolPositionExcitement[0] < 0) {
            this._nearWinReel = -1;
        } else {
            for(let i:number = 0; i < data.nearWinReels.length; i++) {
                if(data.nearWinReels[i] == true) {
                    this._nearWinReel = i;
                    EventHandler.dispatchEvent(new GameEvent(ReelEvent.REEL_ADD_STOP_DELAY, {
                        reelId : this._nearWinReel,
                        delay : 3
                    }));
                    if(this._nearWinReel == 0) {
                        this._b5NearWinView.playNearWinTL(this._b5NearWinPosition[0], this._b5NearWinPosition[1], this.getActiveReelsOnB5NearWin());
                    }
                    break;
                }
            }
        }
    }

    private getActiveReelsOnB5NearWin():number {
        let activeReelsOnB5NearWin:number = 0;
        let numberOfReels:number = 4;
        let numberOfRows:number = 4;

        if(this._lastReelActivated == true) {
            numberOfReels = 5;
        }
        if(this._bottomRowActivated == true) {
            numberOfRows = 5;
        }

        for(let i:number = 0; i < numberOfReels; i++) {
            for(let j:number = 0; j < numberOfRows; j++) {
                if(this._bonusPositionsBeforeSpin[i][j] == false) {
                    activeReelsOnB5NearWin++;
                }
            }
        }

        return activeReelsOnB5NearWin;
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(this._gameData!.mode == BonusBunniesGameMode.BONUS_GAME) {
            if(data.reelId == this._nearWinReel) {
                if(this._endBonusMultiplier > 1) {
                    SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_KEY_LANDING);
                    BonusBunniesGameModuleConfig.bonusBunniesB5WinView.playB5IdleAnimation(this._b5NearWinPosition[0], this._b5NearWinPosition[1]);
                } else {
                    SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.ANTICIPATION_FAIL);
                }
            }
        }
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(this._gameData!.mode == BonusBunniesGameMode.BONUS_GAME) {
            if(data.reelId == (this._nearWinReel - 1)) {
                this._b5NearWinView.playNearWinTL(this._b5NearWinPosition[0], this._b5NearWinPosition[1], this.getActiveReelsOnB5NearWin());
                BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsChestController.loopRumbleChest();
            }
        }

        this.dispatchCompleteEvent(data.reelId);
    }

    public abort():void {
        this._b5NearWinView.removeNearWinAnimation();
    }
}